import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { ChevronDownSVG } from '@sbercloud/uikit-product-icons';
import { ButtonFunction } from '@snack-uikit/button';
import { TEST_IDS } from '../../testIds';
import styles from "./styles.module.css";
import { stopPropagationClick } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CollapseBlockHeaderContainer(_ref) {
  var children = _ref.children,
    toggleExpanded = _ref.toggleExpanded,
    expanded = _ref.expanded,
    actions = _ref.actions;
  var functionLayoutRef = useRef(null);
  var _useState = useState('0px'),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  useEffect(function () {
    setWidth(function () {
      if (functionLayoutRef.current) {
        return getComputedStyle(functionLayoutRef.current, null).getPropertyValue('width');
      }
      return '0px';
    });
  }, [functionLayoutRef]);
  var handleToggleExpanded = function handleToggleExpanded() {
    return toggleExpanded(!expanded);
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _jsxs("div", {
      className: styles.header,
      "data-test-id": TEST_IDS.header,
      onClick: handleToggleExpanded,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.text,
        style: {
          '--width': width
        },
        children: children
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.functionLayout,
        ref: functionLayoutRef,
        onClick: stopPropagationClick,
        children: [actions, /*#__PURE__*/_jsx(ButtonFunction, {
          className: styles.button,
          "data-expanded": expanded || undefined,
          icon: /*#__PURE__*/_jsx(ChevronDownSVG, {}),
          onClick: handleToggleExpanded,
          size: "xs",
          "data-test-id": TEST_IDS.chevron
        })]
      })]
    })
  );
}